import React from 'react';
import { Table } from 'antd';
import NoResultsMessage from '../NoResultsMessage';
import styled from 'styled-components';
import Loop from '../../assets/icons/loop';

const LoadingText = styled.p`
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  color: #546279;
  margin-top: 5px;
`;

const LoadingWrapper = styled.div`
  position: 'absolute';
  top: '50%';
  left: '50%';
  width: 98px;
`;

const TableComponent: React.FC = (props: unknown) => {
  const tableLoading = {
    spinning: props.loading,
    indicator: (
      <LoadingWrapper>
        <Loop
          height={40}
          width={40}
          style={{
            transform: 'rotate(45deg)',
            animation: 'antRotate 1.2s infinite reverse linear',
          }}
        />
        <LoadingText>Cargando información</LoadingText>
      </LoadingWrapper>
    ),
  };
  return (
    <Table
      {...props}
      loading={tableLoading}
      locale={{
        emptyText: <NoResultsMessage loading={props.loading} />,
      }}
    />
  );
};

export default TableComponent;
